import type { AppModule, ModuleAlias } from '../types';

export const MODULE_ORDER: ModuleAlias[] = ['tichete', 'leads', 'check'];
export const MODULE_DESTINATIONS: Record<ModuleAlias, string> = { tichete: '/dashboard', leads: '/leads', check: '/checks' };

export function normalizeModules(value: unknown): AppModule[] {
  const rows = Array.isArray(value) ? value : [];
  const modules = new Map<ModuleAlias, AppModule>();
  for (const candidate of rows) {
    if (!candidate || typeof candidate !== 'object') continue;
    const row = candidate as Record<string, unknown>;
    const raw = String(row.alias || '').toLowerCase();
    const alias = (raw === 'storecheck' ? 'check' : raw) as ModuleAlias;
    if (!MODULE_ORDER.includes(alias)) continue;
    const rawPermissions = row.permissions && typeof row.permissions === 'object' ? row.permissions as Record<string, unknown> : {};
    const item: AppModule = {
      alias,
      label: String(row.label || (alias === 'tichete' ? 'Tichete' : alias === 'leads' ? 'Leads' : 'Check')),
      permissions: { read: rawPermissions.read === true, write: rawPermissions.write === true, delete: rawPermissions.delete === true, admin: rawPermissions.admin === true },
    };
    const previous = modules.get(alias);
    modules.set(alias, previous ? { ...previous, permissions: {
      read: previous.permissions.read || item.permissions.read,
      write: previous.permissions.write || item.permissions.write,
      delete: previous.permissions.delete || item.permissions.delete,
      admin: previous.permissions.admin || item.permissions.admin,
    } } : item);
  }
  return MODULE_ORDER.flatMap((alias) => modules.has(alias) ? [modules.get(alias)!] : []).filter((item) => item.permissions.read);
}

export function moduleDestination(alias: ModuleAlias): string { return MODULE_DESTINATIONS[alias]; }
